import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { ThemeProvider } from './components/ThemeProvider';
import GlobalBackground from './components/GlobalBackground';
import Navbar from './components/Navbar';
import HomePage from './pages/Home';
import ContactPage from './pages/Contact';
import ServicesPage from './pages/Services';
import ShowcasePage from './pages/Showcase';
import ProjectDetailPage from './pages/ProjectDetail';
import AboutPage from './pages/About';
import BlogPage from './pages/Blog';
import BlogPostPage from './pages/BlogPost';
import PrivacyPage from './pages/Privacy';
import ConfirmPage from './pages/Confirm';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

const GoogleAnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title
      });
    }
  }, [location]);

  return null;
};

function App() {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="dark"
      enableSystem
      disableTransitionOnChange
    >
      <Router>
        <div className="flex flex-col min-h-screen bg-black text-white">
          <GlobalBackground />
          <GoogleAnalyticsTracker />
          <ScrollToTop />
          <Navbar />
          <Toaster
            position="top-center"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#18181b',
                color: '#fff',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: '12px',
                padding: '16px',
                fontSize: '14px',
                fontWeight: '500',
                maxWidth: '500px',
              },
              success: {
                iconTheme: {
                  primary: '#10b981',
                  secondary: '#18181b',
                },
                style: {
                  border: '1px solid rgba(16, 185, 129, 0.3)',
                },
              },
              error: {
                iconTheme: {
                  primary: '#ef4444',
                  secondary: '#18181b',
                },
                style: {
                  border: '1px solid rgba(239, 68, 68, 0.3)',
                },
              },
            }}
            containerStyle={{
              top: '80px',
              zIndex: 100,
            }}
          />
          <main className="flex-1 content-elevation">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/showcase" element={<ShowcasePage />} />
              <Route path="/showcase/:id" element={<ProjectDetailPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/confirm" element={<ConfirmPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
